import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Card } from 'react-toolbox/lib/card'
import { Flex, Box } from 'reflexbox'

import { getDayNumber, getMonthString, getYearString, getDayString } from '../../../helpers/DateUtil'
import styles from './styles.scss'

const TimelineDate = (props) => {
  let {
    date
  } = props

  return (
    <Flex styleName='timelineDate'>
      <Box styleName='monthNumberContainer'>
        <span styleName='monthNumber'>
          { getDayNumber(date) }
        </span>
      </Box>
      <Flex styleName='dateTimeContainer' column justify='flex-end'>
        <span styleName='day'>
          { getDayString(date) }
        </span>
        <div>
          <span styleName='month'>
            { getMonthString(date) }
          </span>
          <span styleName='year'>
            { getYearString(date) }
          </span>
        </div>
      </Flex>
    </Flex>
  )
}

TimelineDate.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired
}

export default CSSModules(TimelineDate, styles)
